export const DATEPICKER_ANIMATION_DURATION_MS = 220;
export const DATEPICKER_ANIMATION_TIMING = `${DATEPICKER_ANIMATION_DURATION_MS}ms cubic-bezier(0, 0, 0.2, 1)`;
